import { defineMessages, useIntl } from 'react-intl';

import { GA4FeatureCategory, GA4ItemListName } from '@jsmdg/tracking';
import { type PageType } from '../../../shared/enums/pageType';
import { type SearchResult } from '../../../shared/types/searchResult';
import { ProductSlider } from '../ProductSlider';

type BestsellerSliderProps = {
    readonly initialSearchResult: SearchResult;
    readonly moreResultsLink: string;
    readonly lazyLoad: boolean;
    readonly pageType: PageType;
    readonly verticalPosition?: number;
};

const messages = defineMessages({
    bestsellerProducts: { defaultMessage: 'Beliebte Erlebnisse' },
    bestsellerShowMore: { defaultMessage: 'Mehr entdecken' },
});

const BestsellerSlider = ({
    initialSearchResult,
    lazyLoad,
    moreResultsLink,
    pageType,
    verticalPosition,
}: BestsellerSliderProps): JSX.Element | null => {
    const intl = useIntl();

    const products = initialSearchResult.items;

    if (!products.length) {
        return null;
    }

    return (
        <ProductSlider
            products={products}
            title={intl.formatMessage(messages.bestsellerProducts)}
            urlTitle={intl.formatMessage(messages.bestsellerShowMore)}
            url={moreResultsLink}
            trackingCategory={GA4FeatureCategory.ProductList}
            trackingListName={GA4ItemListName.Bestseller}
            dataTestId="bestseller-slider"
            lazyLoad={lazyLoad}
            pageType={pageType}
            verticalPosition={verticalPosition}
        />
    );
};

export { BestsellerSlider };
